let contactFormSubmit = {
  submitButton: $('#contact_submit'),
  fullNameInput: $('#contact_form_fullName'),
  phoneInput: $('#contact_form_phoneNumber'),
  emailInput: $('#contact_form_email'),
  phoneNumberError: $('#phone-number-error'),
  emailContentError: $('#email-error'),
  phoneError: false,
  emailError: false,

  init: function () {
    this.submitButton.on('click', function (event) {
      event.preventDefault();
    });
    this.form = this.submitButton.closest('form');
    toastr.options.positionClass = 'toast-bottom-center';
    var widget = this.form.find('[data-toggle="recaptcha"]')[0];
    if (widget) {
      var widgetType = widget.getAttribute('data-type');
      var widgetSiteKey = widget.getAttribute('data-site-key');
      var widgetParameters = {
        sitekey: widgetSiteKey,
      };
      if (widgetType === 'invisible') {
        widgetParameters['callback'] = function () {
          app.submitForm(app.form.serialize());
        };
        widgetParameters['size'] = 'invisible';
      }
      var widgetId = grecaptcha.render(widget, widgetParameters);
    }

    let app = this;
    this.submitButton.on('click', function (event) {
      app.form[0].reportValidity();
      if (app.form[0].checkValidity()) {
        event.preventDefault();
        if (!app.phoneError && app.checkPhoneInput() && app.validateEmail()) {
          grecaptcha.execute(widgetId);
          // app.submitForm(app.form.serialize());
        }
      }
    });

    this.fullNameInput.keyup(function () {
      $(this).val($(this).val().replace(/\d+/, ''));
    });
    this.phoneInput.keyup(function () {
      $(this).val($(this).val().replace(/\D/g, '').replace('420', ''));
      if ($(this).val().length > 9 || $(this).val().length < 9) {
        app.phoneNumberError.removeClass('is-hidden');
        app.phoneError = true;
      } else {
        app.phoneNumberError.addClass('is-hidden');
        app.phoneError = false;
      }
    });
    this.emailInput.keyup(function () {
      let email = $(this).val();
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      let valid = re.test(String(email).toLowerCase());
      if (!valid) {
        app.emailContentError.removeClass('is-hidden');
        app.emailError = true;
      } else {
        app.emailContentError.addClass('is-hidden');
        app.emailError = false;
      }
    });
  },
  submitForm: function (serializedForm) {
    let app = this;
    $.ajax({
      url: this.form.attr('action'),
      method: 'POST',
      data: serializedForm,
      beforeSend: function () {
        app.disableButton(true);
      },
      success: function (response) {
        if (response.send) {
          app.showMessage(response.message, 'success');
          $('#book').removeClass('is-open');
          $('.js-booked').addClass('is-open');
          $('body').addClass('is-unscrollable');
        } else {
          app.showMessage(response.message, 'warning');
        }
      },
      error: function (response) {
        app.showMessage(response.responseJSON.message, 'error');
      },
      complete: function (jqXHR, status) {
        app.enableButton();
        app.form[0].reset();
      },
    });
  },
  showMessage: function (message, type) {
    toastr[type](message);
  },
  disableButton: function () {
    this.submitButton.attr('disabled', 'disabled');
  },
  enableButton: function () {
    this.submitButton.attr('disabled', false);
  },
  checkPhoneInput: function () {
    if (this.phoneInput.val().length !== 9) {
      this.phoneNumberError.removeClass('is-hidden');
      this.phoneError = true;

      return false;
    } else {
      this.phoneNumberError.addClass('is-hidden');
      this.phoneError = false;

      return true;
    }
  },
  validateEmail: function () {
    let email = this.emailInput.val();
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    let valid = re.test(String(email).toLowerCase());
    if (!valid) {
      this.emailContentError.removeClass('is-hidden');
      this.emailError = true;

      return false;
    } else {
      this.emailContentError.addClass('is-hidden');
      this.emailError = false;

      return true;
    }
  },
};

function onloadCallback2() {
  contactFormSubmit.init();
}
